import React from 'react';
export function Footer() {
  return <footer className="bg-[#0f1b36] text-white/70 py-16 border-t border-white/10 pt-[30px] pb-[30px]" data-id="element-69">
      <div className="container mx-auto px-4 max-w-[1100px] text-center" data-id="element-70">
        <div className="inline-flex items-center justify-center gap-2 px-6 py-2 rounded-full bg-white/5 border border-white/10 text-white font-bold text-sm tracking-widest uppercase mb-8" data-id="element-71">
          📘 LA AGENDA DEL NIVEL INICIAL
        </div>

        <p className="text-sm max-w-2xl mx-auto mb-10 leading-relaxed text-white/50" data-id="element-72">
          Este producto es una herramienta de organización y planificación para
          docentes de nivel inicial. No constituye asesoramiento pedagógico
          oficial ni reemplaza la formación docente ni la normativa vigente de
          cada institución.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm mb-10 font-medium" data-id="element-73">
          <a href="#" className="hover:text-white transition-colors" data-id="element-74">
            Términos y Condiciones
          </a>
          <span className="text-white/20" data-id="element-75">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-76">
            Política de Privacidad
          </a>
          <span className="text-white/20" data-id="element-77">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-78">
            Contacto
          </a>
        </div>

        <div className="text-xs text-white/40 font-medium" data-id="element-79">
          <p data-id="element-80">
            © 2026 La Agenda del Nivel Inicial — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}